import { render, staticRenderFns } from "./PropertyDetailHeader.vue?vue&type=template&id=314b4b32&scoped=true&"
import script from "./PropertyDetailHeader.vue?vue&type=script&lang=js&"
export * from "./PropertyDetailHeader.vue?vue&type=script&lang=js&"
import style0 from "./PropertyDetailHeader.vue?vue&type=style&index=0&id=314b4b32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "314b4b32",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VChip,VIcon})
